import axios from 'axios';
import { zps_wp } from '../zps';

export type Totals = {
  cid: number;
  total: number;
  paid: number;
};

export type DayliTotals = {
  day: number | string;
  totals: Totals[];
};

export async function fetchDailyTotalsDays(
  controller: AbortController,
  entid: number,
  days: number
): Promise<DayliTotals[]> {
  return axios
    .get<DayliTotals[]>(`${zps_wp}/api/v2/dailyTotals/entity/${entid}/last/${days}/days`, { signal: controller.signal })
    .then(response => response.data);
}

export async function fetchDailyTotalsWeek(controller: AbortController, entid: number): Promise<DayliTotals[]> {
  return axios
    .get<DayliTotals[]>(`${zps_wp}/api/v2/dailyTotals/entity/${entid}/last/week`, { signal: controller.signal })
    .then(response => response.data);
}

export async function fetchDailyTotalsMonth(controller: AbortController, entid: number): Promise<DayliTotals[]> {
  return axios
    .get<DayliTotals[]>(`${zps_wp}/api/v2/dailyTotals/entity/${entid}/last/month`, { signal: controller.signal })
    .then(response => response.data);
}
